<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="container policy">
    <h1 class="policy-title">會員權益政策</h1>
    <p>歡迎使用上聯國際展覽有限公司官方網站（www.top-link.com.tw）及其同網域相關網站（以下簡稱本網站），我們重視會員及使用者之隱私權。請詳細閱讀以下上聯國際展覽有限公司的資料隱私及資訊安全政策，本公司提供服務時，對於客戶資料蒐集、處理及使用皆遵循「個人資料保護法」等相關法令規範。請詳閱以下說明，了解本網站所提供各項服務對於個人資料之使用目的及範圍。</p><br>
    <h2 class="policy-subtitle" >客戶服務與權利義務</h2>
    
    <h3 class="policy-subtitle2" >一般瀏覽</h3>
    <p>
      本網站會保留使用者在上網瀏覽或查詢網頁資料時，經由服務器自行產生的相關記錄，包括主機設備IP地址、使用時間、使用的瀏覽器、瀏覽及點選數據記錄等。本網站會對個別連網者的瀏覽器予以標示，歸納使用者瀏覽器在本網站內部所瀏覽的網頁，除非您願意告知您的個人資訊，否則本網站不會、也無法將此項記錄和您的個人資訊進行對應。</p>
    
    <h3 class="policy-subtitle2" >個資提供及運用</h3>
    <p>
      當您瀏覽、註冊、使用本網站（含相同網域之網頁）服務及參加活動或贈獎時，將收集您的個人識別資料，請務必提供正確資料以便作業。以下為收集資訊列表：</p>
    <p class="partA">
      <span>•	會員帳號、密碼。<br></span>
      <span>•	報名基本資料，包含姓名、身分證號後六碼、性別、生日、居住區域、Email、聯絡電話、聯絡地址及其他必要資訊。<br></span>
      <span>•	其他如基於市場分析、贈獎活動、會員及客戶優惠等相關服務，將會請您提供其他必要資訊（例如身分證正反面影本、戶籍地址及通訊地址…等）。</span>
    </p>
    <p>
      本公司透過本網站及相關服務向您蒐集、處理或利用之個人資料僅提供上聯國際展覽有限公司及其關係企業（包含大通國際展覽有限公司、瑞日鏵國際企業有公司、亞聯國際企業有限公司及其經營之339購物平台）使用，並依法採取適當之安全措施予以保護。未獲個別當事人同意前絕不會透露個人資訊。但若依法須提供檢察機關、法院等官方部門作為以下用途時則不在此限。</p>
    <p class="partA">
      <span>•	法律明文規定。<br></span>
      <span>•	為增進公共利益。<br></span>
      <span>•	為免除當事人之生命、身體、自由或財產上之危險。<br></span>
      <span>•	為防止他人權益之重大危害。<br></span>
      <span>•	經當事人書面同意。<br></span>
    </p><br>

    <h3 class="policy-subtitle2" >為進行服務品質加值、評估及研究</h3>
    <p>
      為提供使用者更精確及優質之服務，本網站得按照資訊保密協議，將使用者數據與第三人數據比較對照。此外，為了向未來的合作夥伴、及其它第三方介紹我們的服務及其它的合法目的，本網站得在不具名的情形之下，揭露使用者之統計資料。
    </p><br>

    <h3 class="policy-subtitle2" >行使個人資料權利方式</h3>
    <p>
      依《個人資料保護法》第3條規定，當事人得就其個人資料，向本公司行使下列權利：
    </p>
    <p class="partA">
      <span>•	查詢或請求閱覽<br></span>
      <span>•	請求製給複製本<br></span>
      <span>•	請求補充或更正<br></span>
      <span>•	請求停止蒐集、處理或利用<br></span>
      <span>•	請求刪除<br></span>
    </p>  
    <p>請注意!!</p>
    <p>
      刪除帳戶後，您將無法在上聯國際展覽之相關網頁中索取票券及兌換獎項，並且會遺失該帳戶中的所有資料和內容，例如已綁定的帳號、檔案、相關票券及抽獎獎項。
    </p><br>

    <h3 class="policy-subtitle2" >用戶如何行使個人資料權利？</h3>
    <p>
      線上客服
    </p>
    <p class="partA">
      <span>•	連線至上聯國際展覽網站。<br></span>
      <span>•	捲動至最下方出現「線上客服（www.messenger.com/t/toplink01）」。<br></span>
      <span>•	點選「線上客服－開啟您的聯絡視窗」。<br></span>
      <span>•	請求停止蒐集、處理或利用<br></span>
      <span>•	與客服聯繫並說明欲行使個人資料權利之項目需求。點選「線上客服－開啟您的聯絡視窗」，與客服聯繫並執行需求。<br></span>
    </p>
    <p>
      電話客服
    </p>
    <p class="partA">
      <span>•	請來電至 02-2759-7167，轉接客服「9」，與客服聯繫並執行需求。<br></span>
    </p>
    <p>
      客服時間
    </p>
    <p class="partA">
      <span>•	週一至週五 10:00-18:00<br></span>
    </p><br>

    <h3 class="policy-subtitle2" >Cookies 使用原則</h3>
    <p>
      為提供個人化服務，我們會使用Cookies技術儲存並追蹤使用者數據。Cookie是從網站傳送到瀏覽器，並保存在使用者計算機硬碟中的簡短資訊。使用者可選擇修改瀏覽器對Cookies的接受程度，包括接受所有Cookies、設定Cookies時得到通知、拒絕所有Cookies等。如果您選擇拒絕所有的Cookies，可能無法使用部份個人化服務或是參與部份的活動。
    </p>
    <p>
      一般而言，我們會依據以下目的及情況，在使用者瀏覽器中寫入並讀取Cookies︰
    </p>
    <p class="partA">
      <span>•	為提供更好、更個人化的服務<br></span>
      <span>&nbsp;&nbsp;方便您參與個人化的互動活動。Cookies 在您註冊或登入時建立，並在您登出時修改。<br></span>
      <span>•	為統計瀏覽人數及分析瀏覽模式<br></span>
      <span>&nbsp;&nbsp;以瞭解網頁瀏覽的情況，做為改善服務的參考。<br></span>
    </p><br>
    
    <h3 class="policy-subtitle2" >資訊安全事項</h3>
    
    <p>1、安全管制與維護：<br>
        <p><span>&emsp;&emsp;（一）本網站</span></p>
        <p class="partA">
          <span>•	會員於本網站註冊個人資料或透過本網站進行網路交易時，將透過適當之安全機制確保機密資料不會輕易遭他人利用。<br></span>
          <span>•	會員個人資料建置於上聯國展覽有限公司內部資料庫，並明訂資料可使用範圍及使用權限。<br></span>
          <span>•	若會員以電話或電子郵件方式查詢或更改個人資料，上聯國展覽有限公司須經相關認證後進行回應，確保會員之權益。<br></span>
        </p>
  
        <p><span>&emsp;&emsp;（二）會員</span></p>
        <p class="partA">
          <span>•	會員帳號、密碼及個人資料應予以保密，不可與他人共用帳號；建議每隔一段時間即變更密碼，以避免帳號及個人資料遭到他人竊取或冒用。<br></span>
          <span>•	使用公用電腦或公共網路服務時切勿儲存會員密碼，服務使用後應登出網頁，勿將個人資料留置於電腦顯示畫面上。<br></span>
        </p>
    </p>
      
    <p>2、本網站設備安全之管理<br>
      <p class="partA">
        <span>•	每日進行備份作業，將所有資料備份到備援主機。<br></span>
        <span>•	定期掃毒，提供會員安全網頁瀏覽環境。<br></span>
        <span>•	設置個人資訊保護諮詢窗口，關於個資防護有疑慮者，請來電上聯國際展覽有限公司 02 2759 7167 #120。<br></span>
      </p><br>
    </p>
    
    <h3 class="policy-subtitle2" >其他事項</h3>
    <p>上聯國際展覽有限公司不定期修改或變更此服務條款之內容，建議您經常閱讀此內容；若修改或變更後繼續使用本服務，將視為您已閱讀、瞭解並同意接受該等修改或變更。如果您不同意本服務條款的內容，或者您所屬的國家或地域排除本服務條款內容之全部或部份時應立即停止使用本服務。</p>
    <p>若未滿二十歲，除應符合上述規定外，並應於您的家長（或監護人）閱讀、瞭解並同意本服務條款之所有內容 (包含其後之修改與變更) 後，方得使用或繼續使用本服務。當您使用或繼續使用本服務時，即推定您的家長（或監護人）已閱讀、瞭解並同意接受本服務條款之所有內容及其後之修改與變更。</p>
    <p>本會員權益政策更新於2022年08月15日生效適用。如有任何問題或建議，請與我們聯繫。</p>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  name: 'policy',
  props: {},
  metaInfo: {
      title: '隱私權政策 │ TopLink 上聯國際展覽有限公司' // set a title
    },
}
</script>
<style>
.policy p{
  color: #8d8c8c;
  font-size: 15px;
  letter-spacing: 1px;
  line-height: 1.6;
  font-weight: 500;
  text-align: justify;
}
.partA{ padding-left: 20px; }
.partB{ padding-left: 40px; }
.policy-title{ padding-bottom: 20px; }
.policy-subtitle{ font-weight: 500; font-size: larger; padding-bottom:20px; }
.policy-subtitle2{ font-weight: 500; }
</style>
